import { useState } from "react";
import "./ClassSlot.scss";
import { PlusIcon, MinusIcon } from "../../assets/global/Icons";

function ClassSlot({
  time,
  type,
  audience,
  spots,
  isRequest,
  onBook,
}: {
  time: string;
  type: string;
  audience: string;
  spots: number;
  isRequest: boolean;
  onBook: (partySize: number) => void;
}) {
  const [partySize, setPartySize] = useState(1);
  const isFull = spots <= 0;

  function increasePartySize() {
    if (partySize < spots) {
      setPartySize((size) => size + 1);
    }
  }

  function decreasePartySize() {
    if (partySize > 1) {
      setPartySize((size) => size - 1);
    }
  }

  return (
    <div className="class-slot flex-container justify-space-between">
      <div>
        <p>
          {time ? (
            <>
              <strong>{time}</strong>
              <br />
            </>
          ) : null}
          {type ? (
            <>
              <strong>{type}</strong>
              <br />
            </>
          ) : null}
          {audience ? (
            <>
              {audience}
              <br />
            </>
          ) : null}
          {isRequest && !time && !type ? (
            <>
              No class scheduled yet
              <br />
            </>
          ) : null}
          <em>{isFull ? "Fully booked" : `${spots} spots left`}</em>
        </p>
      </div>
      <div>
        {!isFull && (
          <div className="booking__actions flex-container justify-space-between">
            <MinusIcon
              onClick={decreasePartySize}
              className={`quantity-icon ${partySize === 1 ? "disabled" : ""}`}
              role="button"
              aria-label="Decrease party size"
              tabIndex={0}
            />
            <span className="booking__number">{partySize}</span>
            <PlusIcon
              onClick={increasePartySize}
              className={`quantity-icon ${partySize === spots ? "disabled" : ""}`}
              role="button"
              aria-label="Increase party size"
              tabIndex={0}
            />
          </div>
        )}
        <button
          type="button"
          className="btn"
          onClick={() => onBook(isFull ? 1 : partySize)}
        >
          {isFull ? "Add to waitlist" : isRequest ? "Request to book" : "Book"}
        </button>
      </div>
    </div>
  );
}

export default ClassSlot;
